import { createSelector } from "reselect";
import orderByName from "../utils/orderByName";

export const getRecommendations = (state) => state.entities.recommendations;

export const getAllRecommendations = createSelector(
  getRecommendations,
  (recommendations) => Object.values(recommendations).sort(orderByName)
);
